import React, { useRef, useState } from "react";
import { message, Button, Form, Input, Row, Col, Modal, Upload } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { dispatchtoast, emailPattern, mobilePattern } from "../../../utils";
import CommonInput from "../../../Common/CommonInput";
import { MenuListendpoint } from "./MenuListEndpoint";
import { PlusOutlined } from "@ant-design/icons";
import { AddMenu_List } from "../../../ApiServices/Apifun";

const AddMenu = ({
    isOpen,
    setIsOpen,
    FetchMenuList,
    from,
    Fill,
    addingCategory,
    addSubcategory,
}) => {
    const [form] = Form.useForm();
    const [logoFile, setLogoFile] = useState(null);
    const [loader, setloader] = useState(false);
    //   const [selectedMember, setSelectedMember] = useState(null);
    const profiledetail = useSelector((state) => state.B2B.profileDetail);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const formRef = useRef(form);
    const handleOk = () => {
        form
            .validateFields()
            .then((values) => {
                form.resetFields();
                // createCategory(values);
            })
            .catch((info) => {
                console.log("Validate Failed:", info);
            });
    };

    const handleCancel = () => {
        setIsOpen(false);
    };



    const handleAddBrand = (val) => {
        const formData = new FormData();

        if (!logoFile) {
            message.error("Please upload a logo");
            return;
        }


        formData.append("foodName", val.foodName);
        formData.append("categoryName", val.categoryName);

        if (logoFile && logoFile instanceof File) {
            formData.append("image", logoFile);
        }

        setloader(true);

        AddMenu_List(formData)
            .then((res) => {
                if (res.status) {
                    dispatchtoast(res.message);
                    setloader(false);
                    setIsOpen(false);
                    FetchMenuList();
                    form.setFieldValue(null)
                } else {
                    setloader(false);
                }
            })
            .catch((err) => {
                console.error(err);
                setloader(false);
            });
    };

    const uploadProps = {
        beforeUpload: (file) => {
            const isImage = file.type.startsWith("image/");
            if (!isImage) {
                message.error("Only image files allowed!");
                return Upload.LIST_IGNORE;
            }
            setLogoFile(file);
            return false;
        },
        fileList: logoFile ? [logoFile] : [],
        onRemove: () => setLogoFile(null),
        listType: "picture-card",
    };





    return (
        <Modal
            footer={null}
            visible={isOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            title={"Add Food Menu"}
        >
            <Form
                form={form}
                ref={formRef}
                name="basic"
                initialValues={{
                    remember: true,
                }}
                onFinishFailed={(err) => console.log(err)}
                onFinish={(val) => handleAddBrand(val)}
            >
                {/* <p className="text-md text-primary font-semibold">Add Member</p> */}
                <p className="mt-4 font-semibold">Member Details</p>
                <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 gap-x-5">
                    <Form.Item
                        name={`foodName`}
                        label={"food Name"}
                        labelCol={{ span: 24 }}
                        rules={[
                            {
                                required: true,
                                message: "Enter Food Name!",
                            },
                            {
                                whitespace: true,
                                message: "Field cannot contain only blank spaces",
                            },
                        ]}
                    >
                        <CommonInput
                            placeholder="Enter Your Food Name"
                            name="foodName"
                        />
                    </Form.Item>

                    <Form.Item
                        name={`categoryName`}
                        label={"Category Name"}
                        labelCol={{ span: 24 }}
                        rules={[
                            {
                                required: true,
                                message: "Enter Category Name!",
                            },
                            {
                                whitespace: true,
                                message: "Field cannot contain only blank spaces",
                            },
                        ]}
                    >
                        <CommonInput
                            placeholder="Please enter your Category Name"
                            name="categoryName"
                        />
                    </Form.Item>{" "}


                    <Form.Item label="Food Image" required>
                        <Upload {...uploadProps}>
                            {!logoFile && (
                                <div>
                                    <PlusOutlined />
                                    <div style={{ marginTop: 8 }}>Upload</div>
                                </div>
                            )}
                        </Upload>
                    </Form.Item>

                </div>

                <div className="flex justify-start items-center mt-2">
                    <Form.Item>
                        <Button
                            loading={loader}
                            htmlType="submit"
                            className="bg-primary outline-none border-none text-white"
                        >
                            Save
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    );
};

export default AddMenu;
